module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.type === 'todo') ? _c('h3', [_vm._v("Radiocarbon Reports")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.type === 'search') ? _c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Radiocarbon Reports")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'col-md-10': (_vm.type === 'search'), 'wrapper': (_vm.type === 'todo'), 'col-md-12': (_vm.type === 'todo')
    }
  }, [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.gridSpec.tableData,
      "columns": _vm.gridSpecColumns,
      "options": _vm.gridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "view",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [(_vm.type === 'search') ? _c('a', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.viewReport(props.row.radioCarbonReportId)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.type === 'todo') ? _c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "to": {
              name: 'CulturalResourceRecording',
              params: {
                culturalResourceRecordingId: props.row.culturalResourceRecordingId,
                startAtTabIndex: 3
              }
            }
          }
        }) : _vm._e()], 1)]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', [_c('modal', {
    ref: "radioCarbonModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Radiocarbon Report")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.closeRadioCarbonModel()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('radioCarbonReport', {
    ref: "radioCarbonReport",
    attrs: {
      "formDisabled": _vm.crrId === null || _vm.formDisabled,
      "culturalResourceId": _vm.culturalResourceId
    },
    on: {
      "radioCarbonNewSave": _vm.radioCarbonNewSave
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-1",
    attrs: {
      "type": "button",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.closeRadioCarbonModel()
      }
    }
  }, [_vm._v("Close")])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0519cde0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabResults.vue
// module id = 887
// module chunks = 1